import React from 'react';
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
const hotelDestinations = {
  'Popular Destinations': ['Hotels in Dubai', 'Hotels in Kathmandu', 'Hotels in France', 'Hotels in Delhi', 'Hotels in Thailand', 'Hotels in Singapore'],
  'Top Cities': ['Hotels in Paris', 'Hotels in London', 'Hotels in New York', 'Hotels in Tokyo', 'Hotels in Sydney', 'Hotels in Rome']
};
const quickLinks = ['About Us', 'Contact Us', 'Careers', 'Blog', 'FAQs', 'Terms & Conditions', 'Privacy Policy'];
const services = ['Holidays', 'Flights', 'Hotels', 'Car Rentals', 'Bus Tickets', 'Travel Insurance'];
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300" data-id="element-38">
      {/* Newsletter Section */}
      <div className="border-b border-gray-800" data-id="element-39">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-40">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-41">
            <div data-id="element-42">
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-43">
                Subscribe to Our Newsletter
              </h3>
              <p className="text-gray-400" data-id="element-44">
                Get exclusive deals and travel inspiration delivered to your
                inbox
              </p>
            </div>
            <div className="flex w-full md:w-auto gap-3" data-id="element-45">
              <input type="email" placeholder="Enter your email" className="flex-1 md:w-72 px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder:text-gray-500 focus:outline-none focus:border-travel-turquoise-500" data-id="element-46" />
              <button className="px-6 py-3 bg-travel-blue-600 text-white font-semibold rounded-xl hover:bg-travel-blue-700 transition-colors flex items-center gap-2" data-id="element-47">
                Subscribe
                <ArrowRight className="w-4 h-4" data-id="element-48" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-49">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12" data-id="element-50">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-51">
            <a href="/" className="flex items-center gap-2 mb-6" data-id="element-52">
              <div className="w-10 h-10 bg-travel-blue-600 rounded-full flex items-center justify-center" data-id="element-53">
                <svg viewBox="0 0 24 24" className="w-6 h-6 text-white" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-54">
                  <circle cx="12" cy="12" r="10" data-id="element-55" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" data-id="element-56" />
                  <path d="M2 12h20" data-id="element-57" />
                </svg>
              </div>
              <span className="text-xl font-bold text-white" data-id="element-58">Travel Sewa</span>
            </a>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed" data-id="element-59">
              Your trusted partner for seamless travel experiences. Book hotels,
              flights, and more with confidence.
            </p>

            {/* Contact Info */}
            <div className="space-y-3" data-id="element-60">
              <a href="tel:+1234567890" className="flex items-center gap-3 text-sm hover:text-travel-turquoise-400 transition-colors" data-id="element-61">
                <Phone className="w-4 h-4" data-id="element-62" />
                +1 (234) 567-890
              </a>
              <a href="mailto:support@travelsewa.com" className="flex items-center gap-3 text-sm hover:text-travel-turquoise-400 transition-colors" data-id="element-63">
                <Mail className="w-4 h-4" data-id="element-64" />
                support@travelsewa.com
              </a>
              <div className="flex items-start gap-3 text-sm" data-id="element-65">
                <MapPin className="w-4 h-4 mt-0.5" data-id="element-66" />
                <span data-id="element-67">123 Travel Street, Tourism City, TC 12345</span>
              </div>
            </div>
          </div>

          {/* Hotel Destinations */}
          {Object.entries(hotelDestinations).map(([title, links]) => <div key={title} data-id="element-68">
              <h4 className="text-white font-semibold mb-4" data-id="element-69">{title}</h4>
              <ul className="space-y-3" data-id="element-70">
                {links.map(link => <li key={link} data-id="element-71">
                    <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm hover:text-travel-turquoise-400 transition-colors" data-id="element-72">
                      {link}
                    </a>
                  </li>)}
              </ul>
            </div>)}

          {/* Services */}
          <div data-id="element-73">
            <h4 className="text-white font-semibold mb-4" data-id="element-74">Our Services</h4>
            <ul className="space-y-3" data-id="element-75">
              {services.map(service => <li key={service} data-id="element-76">
                  <a href={`#${service.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm hover:text-travel-turquoise-400 transition-colors" data-id="element-77">
                    {service}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-78">
            <h4 className="text-white font-semibold mb-4" data-id="element-79">Quick Links</h4>
            <ul className="space-y-3" data-id="element-80">
              {quickLinks.map(link => <li key={link} data-id="element-81">
                  <a href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm hover:text-travel-turquoise-400 transition-colors" data-id="element-82">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800" data-id="element-83">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-84">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-85">
            <p className="text-sm text-gray-500" data-id="element-86">
              © {new Date().getFullYear()} Travel Sewa. All rights reserved.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-4" data-id="element-87">
              {[{
              icon: Facebook,
              label: 'Facebook'
            }, {
              icon: Twitter,
              label: 'Twitter'
            }, {
              icon: Instagram,
              label: 'Instagram'
            }, {
              icon: Youtube,
              label: 'YouTube'
            }].map(({
              icon: Icon,
              label
            }) => <a key={label} href={`#${label.toLowerCase()}`} className="p-2 rounded-full bg-gray-800 text-gray-400 hover:bg-travel-blue-600 hover:text-white transition-colors" aria-label={label} data-id="element-88">
                  <Icon className="w-4 h-4" data-id="element-89" />
                </a>)}
            </div>
          </div>
        </div>
      </div>
    </footer>;
}